import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderState } from './loader.interface';
import { LoaderService } from './loader.service';

@Component({
  selector: 'angular-loader',
  templateUrl: 'loader.component.html',
  standalone: false,
})
export class LoaderComponent implements OnInit, OnDestroy {
  @ViewChild('loadingModal', { static: true })
  public loadingModal: LoaderComponent;

  public display: boolean = false;

  private subscription: Subscription;

  constructor(private loaderService: LoaderService) {}

  ngOnInit() {
    this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
      this.display = state.show;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
